import { useDispatch } from "react-redux";
import { addCartToWishlistThunk } from "~/features/wishlist/redux/wishlistSlice";
import BulkAddToWishlistFlow, {
  type BulkAddToWishlistFlowProps,
} from "~/features/orders/orderDetails/components/AddToWishlist/BulkAddToWishlistFlow";

type SelfProps = Pick<BulkAddToWishlistFlowProps, "onClose" | "info">;

export default function AddCartToWishlistPopupFlow(props: SelfProps) {
  const { onClose, info } = props;
  const dispatch = useDispatch();

  const handleAddToWishlist = (data: { wishlistId: string } | { wishlistName: string }) => {
    const dataToSend = "wishlistId" in data ? { id: data.wishlistId } : data;
    return dispatch(addCartToWishlistThunk(dataToSend));
  };

  return <BulkAddToWishlistFlow onClose={onClose} onAddToWishlist={handleAddToWishlist} info={info} />;
}
